import { render } from "./RecursiveList.vue?vue&type=template&id=5cf13866&scoped=true"
import script from "./RecursiveList.vue?vue&type=script&lang=js"
export * from "./RecursiveList.vue?vue&type=script&lang=js"

import "./RecursiveList.vue?vue&type=style&index=0&id=5cf13866&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cf13866"]])

export default __exports__